import { connect } from 'react-redux';
import type { ActionCreator } from 'redux';
import type { OverrideValues, PaleState } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';
import { DistanceSlider, type DistanceSliderDispatchProps, type DistanceSliderStateProps } from './DistanceSlider';

export const mapStateToProps = ({ filters }: PaleState): DistanceSliderStateProps => ({
    id: 'distanceToBeachFilter',
    label: 'Avstand til strand',
    min: 0,
    max: 5000,
    initialDistance: filters.distanceToBeach ? filters.distanceToBeach[1] : undefined,
});

export const mapDispatchToProps: OverrideValues<DistanceSliderDispatchProps, ActionCreator<unknown>> = {
    distanceChange: actions.filterDistanceToBeach,
    triggerFetch: fetchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(DistanceSlider);
